import parseCookie from './parseCookie';
import getCookie from './getDocumentCookie';
import { EDGE_EXPERIMENT_COOKIE } from '../hooks/useEdgeExperiment';

interface TrackElectionPayload {
  feature_slug: string;
  visitor_id: string;
  account_id?: number; // if logged in
  is_control: boolean;
}

export function getSessionKey(featureName: string) {
  return `_PP_ELECTION_TRACKED_${featureName}`;
}

const NON_FEATURE_KEYS = ['session_id', 'updated_at'];

function getTrackingUrl() {
  return window.location.href.indexOf('www') !== -1
    ? 'https://trk.ppassets.com/experiments'
    : 'https://earth-trk.ppassets.com/experiments';
}

function pingBucketingEndpoint(election: TrackElectionPayload) {
  const base64Payload = btoa(JSON.stringify(election));
  return fetch(`${getTrackingUrl()}?data=${base64Payload}`);
}

// This logic is split off from the above useEdgeExperiment hook to be called at page load rather than tied to asking for an election via featureName in the hook
export function trackEdgeExperiments(accountID?: number) {
  try {
    const cookie = getCookie();
    if (!cookie || typeof cookie !== 'string') return null;
    // convert string to javascript object with 'edgeExperiments' key containing the 'featureName: { ...election }' map
    const parsedCookie = parseCookie(EDGE_EXPERIMENT_COOKIE, cookie);
    // prevent this call to tracking endpoint from happening on the server
    if (window && window.sessionStorage && parsedCookie) {
      // for each featureName in the experiments cookie, ping the tracking endpoint once per unique session
      Object.keys(parsedCookie).forEach((featureName) => {
        if (
          !NON_FEATURE_KEYS.includes(featureName) &&
          window.sessionStorage.getItem(getSessionKey(featureName)) !== 'true'
        ) {
          const rawElection = parsedCookie[featureName];
          if (!rawElection || typeof rawElection === 'string') return {};
          const payload: TrackElectionPayload = {
            ...rawElection,
            feature_slug: featureName,
            visitor_id: parsedCookie.session_id,
            is_control: !!rawElection?.is_control,
          };
          if (accountID) payload.account_id = accountID;
          pingBucketingEndpoint(payload).then((res: any) => {
            // if the election tracking is successful add a sessionStorage key to prevent duplicate calls
            if (res?.status === 200) {
              window.sessionStorage.setItem(getSessionKey(featureName), 'true');
            }
          });
        }
      });
    }
  } catch (error) {
    console.error(error);
    return null;
  }
}
